import { FC, ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginType, useAuthContext } from '../services/auth.service';
import { getversion } from "../version";
import './login.scss';

/* -------------------------------------------------------------------------------- *\
|                               LoginPage
\* -------------------------------------------------------------------------------- */
export const LoginPage: FC<{ children?: ReactNode }> = () =>
{
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const auth = useAuthContext();
    const navigate = useNavigate();

    /* -------------------------------------------------------------------------------- *\
    |                               onSubmit
    \* -------------------------------------------------------------------------------- */
    const onSubmit = (e: React.FormEvent) =>
    {
        e.preventDefault();
        if (!auth) return;

        setError('');
        setLoading(true);
        const values: LoginType = { username, password };
        auth.login(values).then(
            () =>
            {
                setLoading(false);
                navigate('/');
            },
            (err) =>
            {
                const msg = err.response?.data?.message || err.message || String(err);
                setError(msg);
                setLoading(false);
            }
        );
    };

    const version = getversion();

    return (
        <div className="login">
            <h1><em>McLloyd</em> race tools</h1>
            <form className="login__form" onSubmit={onSubmit}>
                <label className="login__form__label">Utilisateur</label>
                <input
                    className="login__form__input"
                    placeholder="login"
                    autoFocus
                    disabled={loading}
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                />

                <label className="login__form__label">Mot de passe</label>
                <input
                    className="login__form__input"
                    type="password"
                    placeholder="password"
                    disabled={loading}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />

                {error && <div className="login__form__error">{error}</div>}

                <button className="login__form__button" type="submit" disabled={loading}>
                    {loading ? '...' : 'Login'}
                </button>
            </form>
            <div className="login__version">{version}</div>
        </div>
    );
};
